<script>
    export default {
        name: "FeaturedOnIcons",
        props: {
            list: {
                type: Object,
                required: true
            }
        }
    };
</script>

<template>
    <div class="@container">
        <div class="mobile:@grid mobile:@grid-cols-12 tablet:@flex @text-center @gap-8 tablet:@gap-x-12 @justify-center @items-center">
            <div
                v-for="(img, i) in list"
                :key="i"
                class="mobile:@col-span-4 @text-center"
            >
                <img class="@h-auto @max-w-full" :src="$cld.url(img.image)" :alt="img.image.original_filename">
            </div>
        </div>
    </div>
</template>

<style scoped>
    img {
        width: 100px;
        opacity: 0.5
    }
</style>
